module.exports = __webpack_public_path__ + "img/49.c576bbf0.jpg";